import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { hasElements } from "Utils/Array";
import { projectsStagingUpdateStart } from "Store/Actions";
import { selectSelectedOrActiveProjects } from "Store/Selectors/Projects";
import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { IAction } from "./IAction";

export function useStaging(): [boolean, IAction] {
  const dispatch = useDispatch();
  const { preflightAuthentication } = useAuthenticationPreflight();
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const [selectedProject] = selectedProjects;
  const allowStaging = hasElements(selectedProjects) && selectedProjects.length === 1 && !!selectedProject[`@hasUpdate`];

  const onStaging = useCallback(async () => {
    if (!allowStaging) {
      return;
    }

    await preflightAuthentication();
    dispatch(projectsStagingUpdateStart(selectedProject[`@id`]));
  }, [allowStaging, dispatch, preflightAuthentication, selectedProject]);

  return [allowStaging, onStaging];
}
